import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';

export const TextRightsHolderPersonalData = () => (
  <DynamicContent
    configPath={REMOTE_CONFIG_PATHS.PRIVACY_POLICY.RIGHTS_HOLDER_PERSONAL_DATA}
    renderAsHtml={true}
  />
);
